import { Resolver, Query, FieldResolver, Root, Args, Arg, Ctx, Directive } from 'type-graphql'
import { Domain, getQueryBuilderFromListParams, getRepository, ListParam } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'
import type ResolverContext from '@things-factory/auth-base'
import { KpiScope } from './kpi-scope'
import { KpiScopeList } from './kpi-scope-type'

@Resolver(KpiScope)
export class KpiScopeQuery {
  @Directive('@privilege(category: "kpi", privilege: "query", domainOwnerGranted: true, superUserGranted: true)')
  @Query(returns => KpiScope!, { nullable: true, description: 'Fetch a scope dimension definition by ID' })
  async kpiScope(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<KpiScope> {
    const { domain } = context.state

    return await getRepository(KpiScope).findOne({
      where: { domain: { id: domain.id }, id }
    })
  }

  @Query(returns => KpiScopeList, { description: 'Fetch multiple scope dimension definitions' })
  @Directive('@privilege(category: "kpi", privilege: "query", domainOwnerGranted: true, superUserGranted: true)')
  async kpiScopes(
    @Args(type => ListParam) params: ListParam,
    @Ctx() context: ResolverContext
  ): Promise<KpiScopeList> {
    const { domain } = context.state

    const queryBuilder = getQueryBuilderFromListParams({
      domain,
      params,
      repository: await getRepository(KpiScope),
      searchables: ['name', 'description'],
      filtersMap: {
        level: { columnName: 'level' },
        scopeType: { columnName: 'scopeType' },
        parentLevel: { columnName: 'parentLevel' },
        active: { columnName: 'active' },
        includeInStatistics: { columnName: 'includeInStatistics' },
        showInDashboard: { columnName: 'showInDashboard' }
      }
    })

    const [items, total] = await queryBuilder.getManyAndCount()

    return { items, total }
  }


  @FieldResolver(type => Domain)
  async domain(@Root() kpiScope: KpiScope): Promise<Domain> {
    return kpiScope.domainId && (await getRepository(Domain).findOneBy({ id: kpiScope.domainId }))
  }

  @FieldResolver(type => User)
  async updater(@Root() kpiScope: KpiScope): Promise<User> {
    return kpiScope.updaterId && (await getRepository(User).findOneBy({ id: kpiScope.updaterId }))
  }

  @FieldResolver(type => User)
  async creator(@Root() kpiScope: KpiScope): Promise<User> {
    return kpiScope.creatorId && (await getRepository(User).findOneBy({ id: kpiScope.creatorId }))
  }
}